// react-window 2.x uses Object.hasOwn (ES2022), which CRA3's babel does not polyfill
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (obj, prop) => Object.prototype.hasOwnProperty.call(Object(obj), prop),
    configurable: true,
    writable: true,
  });
}
